import React, {useState, useEffect, Fragment} from 'react';
import { Link } from 'react-router-dom';
import flatstore from 'flatstore';
import parse from 'html-react-parser';
import {getMeatcuts} from '../../../utils/services';
import axios from 'axios';
import { currentLang, apiURL, meatcutURL } from '../../../utils/functions';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
import Image from '../Image';

const MeatcutOverview = ({meatcuts_data, animalId}) => {
    const [data, setData] = useState(null);
    const { t } = useTranslation();
    //console.log(animalId);
    

    useEffect(() => {
        meatcuts_data = null;
        let url = apiURL()+"/meatcuts/animal/"+animalId;
        if(isNil(data)){
            try{
                axios.get(url, {}).then(function(response){
                    setData(response.data);
                });
            }catch(err){
                console.log(err);
            }
        }
    }, [])

    return (
        <div className="container">
        <div className="row">
            {data && data.map((item, index)=>{
                var url = meatcutURL(item.slug);
                return (
                    <div key={index} className="col-xs-12 col-md-6 col-lg-4">
                        <div className="list__item">
                            <div className="list__body">
                                <div className="list__image">
                                    <a className="read-more" href={url}>
                                        <Image src={item.image_url} alt={item.title} />
                                    </a>
                                </div>
                                <div className="list__description">
                                    <div>
                                        <h3 className="title">
                                            <a className="text--white" href={url}>{item.title}</a>
                                        </h3>
                                        <p className="excerpt text--white">{item.summary && parse(item.summary)}</p>
                                    </div>
                                    <a className="read-more" href={url}>{t('meatcuts.view_cooking_instructions')}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
        </div>
    )
}

export default flatstore.connect(['meatcuts_data'])(MeatcutOverview);